<template>
    <img src="@/assets/bg-1.svg" alt="Background Decoration" class="absolute xl:top-0 xl:right-0 lg:top-0 lg:right-0 md:top-0 md:right-0 z-10 w-full xl:w-auto lg:w-full md:w-full opacity-100 xl:block hidden">
   <section class="relative w-full flex flex-col-reverse xl:flex-col lg:flex-col items-start justify-between font-poppins bg-white mt-24 md:mt-0 sm:py-10 md:py-0 xl:py-20  md:pt-20 px-6 md:px-0 lg:px-10 xl:px-12 z-0">
     
     <img src="@/assets/bg 4.svg"  alt="Background" class="absolute inset-0 lg:pt-28 w-full h-full object-cover z-10 xl:hidden">
     <img src="@/assets/elemen.svg" alt="" class="absolute top-30 left-0 z-0 xl:block hidden">
   
   <div class="w-full xl:w-1/2 text-start px-2 md:px-12 xl:px-10 z-10 mb-10 py-10">
      <h2 class="text-2xl sm:text-4xl md:text-4xl xl:text-4xl font-semibold xl:text-gray-700 lg:text-white md:text-white text-white max-w-3xl">
        <span class="relative inline-block lg:pt-10 md:pt-20 pt-5">
         Welcome to PHISOFT
          <span class="absolute bottom-1 left-0 w-full h-2 bg-[#18a0c7] opacity-30"></span>
        </span>
      </h2>
      <p class="xl:text-gray-700 lg:text-white md:text-white text-white text-base md:text-md lg:text-md xl:text-lg pt-2 lg:pt-5">by PSG Group</p>
      <p class="xl:text-gray-800 lg:text-white md:text-white text-white xl:text-lg lg:text-xl md:text-md text-sm  text-justify font-light antialiased leading-relaxed max-w-7xl mt-8">
       PT Pasifik Hoki Indonesia (PHISOFT) was founded with the goal of developing a superior system to support the growth of all businesses. We have faced considerable competition and overcame 
       numerous challenges in our pursuit to demonstrate that our technology is the best.
      </p>
    </div>
   
     <img src="@/assets/bg.svg" alt="Background" class="absolute bottom-0 right-0 w-1/3 object-cover z-0">
   </section>
 </template>
 
 <script>

export default {
  name: 'AboutHero',
  data() {
    return {
      visible: false
    };
  },
  mounted() {
    // Simple entrance animation
    setTimeout(() => {
      this.visible = true;
    }, 100);
    
  },
};
</script>
<style>

</style>